export function TeachersSetupHeader() {
  return (
    <div>
      <div className="text-xl font-extrabold tracking-tight text-gray-900">
        Onboard Staff
      </div>
      <div className="mt-1 text-sm text-gray-600">
        Create teachers, assign attendance sections, and manage staff access.
      </div>
    </div>
  );
}
